import React from 'react';
import HomeHero from '../components/home/HomeHero';
import SimShowcase from '../components/home/SimShowcase';
import JoinBanner from '../components/home/JoinBanner';
import CoursesSection from '../components/CoursesSection';
import TestimonialsSection from '../components/TestimonialsSection';
import Newsletter from '../components/Newsletter';

const Home = () => {
  return (
    <main data-testid="home-page" className="bg-slate-50 text-slate-900">
      <HomeHero />
      <SimShowcase />
      <CoursesSection />
      <JoinBanner />
      <TestimonialsSection />
      <Newsletter />
    </main>
  );
};

export default Home;
